import {
  PLACE_ORDER_DISABLED_TOOLTIP,
  PLACE_ORDER_PRICE_ZERO_DISABLED_TOOLTIP,
  PLACE_ORDER_REJECTED_DISABLED_TOOLTIP,
} from '@/constants/Order';

import type { IReviewOrderItem } from '@/common/interfaces/order.interface';

export interface SizeInfo {
  [size: string]: string | number;
  minQuantity: number;
  total: number;
}

/**
 * Method to determine if the order item sizes are valid.
 *
 * @param sizes - Order Item Sizes Information.
 */
export const isOrderItemSizesValid = (sizes: Record<string, SizeInfo>) => {
  if (sizes) {
    const orderItemSizeValidFlags: boolean[] = [];

    Object.keys(sizes).forEach((key: string) => {
      orderItemSizeValidFlags.push(sizes[key].total >= sizes[key].minQuantity);
    });

    return orderItemSizeValidFlags.every((flag) => flag);
  }

  return false;
};

/**
 * This function is used to get the tooltip title based on the conditions
 * @param prize0Item
 * @param enableOrder
 * @returns
 */
export const getTooltipTitle = (
  prize0Item: boolean,
  enableOrder: boolean,
  isOrderHasRejectedItems: boolean
) => {
  if (prize0Item) {
    return PLACE_ORDER_PRICE_ZERO_DISABLED_TOOLTIP;
  }

  if (isOrderHasRejectedItems) {
    return PLACE_ORDER_REJECTED_DISABLED_TOOLTIP;
  }

  if (!enableOrder) {
    return PLACE_ORDER_DISABLED_TOOLTIP;
  }

  return '';
};

/**
 * Method to determine if the order can place or not.
 *
 * @param items - Cart Items
 */
export const isOrderHasLicensingRejectionItems = (items: IReviewOrderItem[]) => {
  const isOrderContainsRejectedItems = items.some(
    (item) =>
      item.designRejectionInfo?.isDesignSelfBlockedForCheckout ||
      item.designRejectionInfo?.isDesignLicensingRejected
  );

  return isOrderContainsRejectedItems;
};
